import breakpoints from '../../../theme/breakpoints'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`

  .card {
    flex: 0 0 auto;
    display: flex;
    width: 33.33%;
    box-sizing: border-box;
    padding: 12px 6px 30px;
  }
  
  .card:nth-child(3n-2) {
    padding-left: 0px;
    padding-right: 12px;
  }
  
  .card:nth-child(3n) {
    padding-right: 0px;
    padding-left: 12px;
  }
  
  .card-content {
    display: flex;
    flex-direction: column;
  }
  
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0 9px;
  }
  
  .card-title {
    font-family: Graphik;
    font-style: normal;
    font-weight: 500;
    font-size: 1.22em;
    line-height: 130%;
    color: ${redesignedTheme.colors.mineShaft};
    box-sizing: border-box;
    display: flex;
    margin-top: 16px;
  }
  
  .timestamp {
    display: flex;
    align-items: center;
    color: rgb(70, 70, 70);
    font-size: 16px;
    font-weight: 300;
  }
  
  .play-video {
    width: 25px;
    height: 22px;
    border-radius: 10px;
    background: ${redesignedTheme.colors.lightBlue};
    padding-left: 2px;
    text-align: center;
    line-height: 23px;
    margin-left: 8px;
  }
  
  .play-icon {
    width: 11px;
    height: 11px;
  }
  
  .meatball-icon {
    padding: 0;
  }
  
  .play-icon {
    margin-bottom: 2px;
  }  
  
  @media only screen and (max-width: 1279px) {
    .card {
      width: 50%;
    }
    
    .card:nth-child(2n+1) {
      padding-left: 0px;
      padding-right: 12px;
    }
    
    .card:nth-child(2n) {
      padding-right: 0px;
      padding-left: 12px;
    }
  }
  
  @media only screen and (max-width: ${breakpoints.md}px) {
    .card:nth-child(n) {
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 30px;
    }
  }  
`
